import YouTubeAdapter from './youtube';
import VimeoAdapter from './vimeo';
import KalturaAdapter from './kaltura';
import JWPlayerAdapter from './jwplayer';
import VideoJSAdapter from './videojs';
import BrightcoveAdapter from './brightcove';
import VidyardAdapter from './vidyard';
import MediasiteAdapter from './mediasite';
import PanoptoAdapter from './panopto';

export const findVideos = () => [].concat(
    YouTubeAdapter.findVideos(),
    VimeoAdapter.findVideos(),
    KalturaAdapter.findVideos(),
    JWPlayerAdapter.findVideos(),
    BrightcoveAdapter.findVideos(),
    VideoJSAdapter.findVideos(),
    VidyardAdapter.findVideos(),
    MediasiteAdapter.findVideos(),
    PanoptoAdapter.findVideos(),
);

const adapters = {
    youtube: YouTubeAdapter,
    kaltura: KalturaAdapter,
    vimeo: VimeoAdapter,
    jwplayer: JWPlayerAdapter,
    videojs: VideoJSAdapter,
    brightcove: BrightcoveAdapter,
    vidyard: VidyardAdapter,
    mediasite: MediasiteAdapter,
    panopto: PanoptoAdapter,
};

export const getAdapter = (provider) => new adapters[provider]();



// WEBPACK FOOTER //
// ./scripts/adapters/index.js